var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0855 18.9137C42.2092 16.0334 40.0481 16.4654 40.0481 16.4654L29.9711 26.5413L18.4545 38.0565L16.4407 47.5561L25.941 45.5419L47.5356 23.9518C47.5356 23.9518 47.9666 21.7929 45.0855 18.9137ZM25.3753 44.3992L22.1355 45.0964C21.8233 44.5108 21.4468 43.9284 20.7588 43.2376C20.0705 42.5492 19.4845 42.1716 18.8986 41.8602L19.5958 38.6197L20.5331 37.6864C20.5331 37.6864 22.2976 37.7209 24.2837 39.7109C26.273 41.7023 26.3111 43.4616 26.3111 43.4616L25.3753 44.3992Z",
    fill: "#F70303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7773 31.0191L24.1383 29.6584L17.9607 23.4803L23.4799 17.9611L24.7552 19.2365L23.0358 20.9559C22.6592 21.331 22.66 21.9412 23.0358 22.3163C23.4109 22.6928 24.0196 22.6928 24.3961 22.3163L26.1155 20.5968L28.4675 22.9474L26.7474 24.6682C26.3715 25.0433 26.3715 25.6535 26.7481 26.0286C26.9543 26.2351 27.2298 26.3169 27.5004 26.2963L31.0179 22.7781L24.7182 16.4785C24.0356 15.7959 22.8687 15.8499 22.1185 16.6005L16.6 22.12C15.8501 22.8702 15.7957 24.0357 16.4787 24.7198L22.7773 31.0191Z",
    fill: "#F70303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.52 39.2801L41.2243 32.9844L37.6215 36.5872C37.6442 36.7966 37.7228 37.0028 37.8839 37.1639C38.259 37.5404 38.8673 37.5404 39.2435 37.1639L40.9637 35.4441L43.3149 37.796L41.5948 39.5158C41.2189 39.8909 41.2189 40.5011 41.5948 40.8758C41.9713 41.2527 42.5796 41.2527 42.9558 40.8758L44.6752 39.1564L46.0377 40.5192C46.037 40.5192 46.037 40.5192 46.037 40.5192L40.5189 46.0387L34.3447 39.8646L32.9837 41.225L39.2801 47.521C39.9635 48.204 41.1293 48.1496 41.8799 47.4005L47.3984 41.8813C48.15 41.1297 48.2034 39.9638 47.52 39.2801Z",
    fill: "#F70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovative);
export default __webpack_public_path__ + "static/media/Innovative.2238836197d004eeced18f248858ed77.svg";
export { ForwardRef as ReactComponent };